export enum UsageOrderDirection {
    Asc = 'asc',
    Desc = 'desc',
}
